/**
 * Admin > Pre-Market Diagnostics -- single read-only GET call. See
 * `app.services.pre_market_diagnostics_service` on the backend for what
 * each check covers.
 */
import api from "@/services/api";
import type { PreMarketDiagnosticsResponse } from "@/types";

export const preMarketDiagnosticsService = {
  run: async (): Promise<PreMarketDiagnosticsResponse> => {
    const { data } = await api.get<PreMarketDiagnosticsResponse>("/admin/diagnostics/pre-market");
    return data;
  },
};

export default preMarketDiagnosticsService;
